export default __webpack_public_path__ + "static/media/logo.6884131b.jpeg";